import { useState, useEffect } from 'react';
import useSWR from 'swr';
import Cookies from 'js-cookie';

import { IRepository } from '@/types';
import { IResponseError } from '@/lib/apiBase';
import { IDirectoryDiffTreeResponse } from '@/lib/diffApi';
import { fetchDirectoryDiffTree } from '@/lib/diffApi';

interface useDirectoryDiffTreeParams {
  repository: IRepository;
  base: string;
  head: string;
  initialData?: IDirectoryDiffTreeResponse | undefined;
}

const useDirectoryDiffTree = ({ repository, base, head, initialData }: useDirectoryDiffTreeParams) => {
  const token = Cookies.get('oxen_user_token');

  const [status, setStatus] = useState<'success' | 'error' | 'pending'>('pending');
  const [response, setResponse] = useState<IDirectoryDiffTreeResponse | undefined>(initialData);
  const [error, setError] = useState<IResponseError | undefined>();

  // const pathWithBranch = [branch, path].join('/');

  const { data, isLoading, isValidating } = useSWR(
    [repository.namespace, repository.name, base, head, token],
    () => fetchDirectoryDiffTree({ repository, baseRef: base, headRef: head, token: token }),
    {
      fallbackData: initialData,
      keepPreviousData: true,
      revalidateOnFocus: false,
      // revalidateOnMount: false,
      revalidateOnReconnect: false,
      // focusThrottleInterval: FOCUS_THROTTLE_INTERVAL,
    },
  );

  useEffect(() => {
    if (data) {
      setResponse(data);
      setStatus(data?.status);
      setError(data?.error as IResponseError);
    }
  }, [data]);

  return {
    status: status,
    isLoading: isLoading,
    isValidating: isValidating,
    response: response,
    error: error,
  };
};

export default useDirectoryDiffTree;
